import {useEffect, useState} from 'react';
import breakpoints from '@config/breakpoints';

const
    bp = breakpoints,
    mediaQuery = {min: {}, max: {}};

for ( let key in bp ) {
    if ( bp.hasOwnProperty( key ) ) {
        mediaQuery.min[key] = `screen and (min-width: ${bp[key]}px)`;
        mediaQuery.max[key] = `screen and (max-width: ${bp[key]}px)`;
    }
}

const getBreakPointAlias = () => {
    /* Conditional CSS http://adactio.com/journal/5429/ */
    if ( window.getComputedStyle ) {
        return window
            .getComputedStyle( document.body, ':after' )
            .getPropertyValue( 'content' )
            .replace( /\"/g, '' )
            .trim();
    }
    // default to large if getComputedStyle not available
    return 'large';
};

const getCurrentBreakPoint = () => {
    let alias = getBreakPointAlias();
    // uppercase first letter
    alias = alias.charAt( 0 ).toUpperCase() + alias.slice( 1 );
    return breakpoints['screen' + alias];
};

export const useMediaQuery = ( query ) => {
    const mediaMatch = typeof window !== 'undefined' && window.matchMedia( query );
    const [matches, setMatches] = useState( mediaMatch?.matches );

    useEffect( () => {
        if ( !mediaMatch ) {
            return null;
        }

        const handler = e => setMatches( e.matches );
        mediaMatch.addEventListener( 'change', handler );
        return () => mediaMatch.removeEventListener( 'change', handler );
    } );

    return matches;
}

export default {
    ...mediaQuery,
    getBreakPointAlias,
    getCurrentBreakPoint
};
